module.exports = __webpack_public_path__ + "img/ahorcadoNuevo0.8e7fdcaf.png";